import { LngLatLike, useMap } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { mapViewState } from '../../../storage/map';

export function useMapActions() {
  const { map } = useMap();
  const mapView = useRecoilValue(mapViewState);

  const zoomTo = (position: LngLatLike, zoom: number = 16) => {
    map?.flyTo({
      zoom: mapView.zoom < zoom ? zoom : mapView.zoom,
      center: position,
      duration: 1500,
      essential: true,
    });
  };

  return { zoomTo };
}
